export default "__VITE_ASSET__800b2676__"